import { render, staticRenderFns } from "./memberKindTab.vue?vue&type=template&id=7bcdfde6&"
import script from "./memberKindTab.vue?vue&type=script&lang=js&"
export * from "./memberKindTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports